import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { MySwal } from "../../../library/swal";
import axios from "../../../library/axios";
import { getSlug } from "../../../config/routes/guards/slug";
import { getApiErrorMessage } from "../../../helpers/apiErrorMessage";
import { notifyApiLoadError } from "../../../helpers/notifyApiError";

// Form edit metadata dokumen yang sudah terlanjur diunggah.
// Hanya nama & deskripsi yang bisa diubah; untuk mengganti berkasnya user
// tetap harus menghapus dokumen lalu mengunggah ulang.
const EditDocumentSupportComp = (props) => {
  const [namaFile, setNamaFile] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const authHeader = {
    Authorization: `Bearer ${localStorage.getItem(
      `token${getSlug() ? "-" + getSlug() : ""}`
    )}`,
  };

  useEffect(() => {
    let active = true;

    const fetchDocument = async () => {
      if (!props?.documentId) {
        setFetching(false);
        setNotFound(true);
        return;
      }

      setFetching(true);
      setNotFound(false);
      try {
        const { data } = await axios({
          url: `/skor/show-dokumen/${props.documentId}`,
          method: "GET",
          headers: { "Access-Control-Allow-Origin": "*", ...authHeader },
        });
        if (!active) return;

        if (!data?.data) {
          setNotFound(true);
          return;
        }
        setNamaFile(data?.data?.namaFile || "");
        setDeskripsi(data?.data?.Deskripsi || "");
      } catch (err) {
        if (!active) return;
        setNotFound(true);
        notifyApiLoadError(err, "components/moleculs/document-support/edit.fetchDocument");
      } finally {
        if (active) setFetching(false);
      }
    };

    fetchDocument();
    return () => {
      active = false;
    };
  }, [props?.documentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = () => {
    if (!namaFile.trim()) {
      MySwal.fire({
        icon: "warning",
        title: "Nama Dokumen Kosong",
        text: "Silakan isi nama dokumen terlebih dahulu sebelum menyimpan.",
      });
      return;
    }

    setLoading(true);
    axios({
      url: `/skor/update-dokumen/${props.documentId}`,
      method: "PATCH",
      data: {
        namaFile: namaFile.trim(),
        Deskripsi: deskripsi,
      },
      headers: authHeader,
    })
      .then(() => {
        MySwal.fire({
          icon: "success",
          title: "Success",
          text: "Berhasil memperbarui dokumen!",
        });

        props.fetch();
        props.close();
      })
      .catch((err) => {
        // Sesi habis / akses ditolak sudah ditangani (beserta pesannya) oleh
        // interceptor axios, jangan tampilkan alert ganda.
        if (err?.isHandledByInterceptor) return;

        MySwal.fire({
          icon: "error",
          title: "Dokumen Gagal Disimpan",
          text: getApiErrorMessage(
            err,
            "Perubahan dokumen gagal disimpan. Silakan coba lagi, dan hubungi administrator bila tetap gagal."
          ),
        });
      })
      .finally(() => setLoading(false));
  };

  if (fetching) {
    return <p className="text-info mb-0">Memuat data dokumen..</p>;
  }

  if (notFound) {
    return (
      <>
        <p className="text-danger">
          Data dokumen tidak ditemukan. Silakan tutup form ini, muat ulang
          halaman, lalu coba lagi.
        </p>
        <Button variant="danger" size="sm" onClick={() => props.close()}>
          Tutup
        </Button>
      </>
    );
  }

  return (
    <>
      <div className="mb-3 row">
        <label htmlFor="editNamaFile" className="col-sm-12 col-form-label required">
          Nama Dokumen
        </label>
        <div className="col-12">
          <input
            type="text"
            className="form-control"
            id="editNamaFile"
            value={namaFile}
            onChange={(e) => setNamaFile(e.target.value)}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="editDeskripsi" className="col-sm-12 col-form-label">
          Deskripsi
        </label>
        <div className="col-12">
          <textarea
            className="form-control"
            id="editDeskripsi"
            rows={3}
            value={deskripsi}
            onChange={(e) => setDeskripsi(e.target.value)}
          ></textarea>
          <small className="text-info">
            Deskripsi ini akan tampil saat dokumen dibuka.
          </small>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={loading}
            variant="success"
            size="sm"
            onClick={() => handleSubmit()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditDocumentSupportComp;
